var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.904 31.8042V16.1995C40.9034 14.8308 40.1852 13.5625 39.0118 12.8575L26.0079 5.05516C25.4019 4.69175 24.7088 4.5 24.0021 4.5C23.2956 4.5 22.6022 4.69176 21.9962 5.05516L8.99227 12.8575C7.81655 13.5608 7.09586 14.8295 7.09375 16.1995V31.8042C7.09438 33.173 7.81254 34.4412 8.98593 35.1463L21.9899 42.9486C22.5958 43.312 23.289 43.5038 23.9957 43.5038C24.7022 43.5038 25.3956 43.312 26.0016 42.9486L39.0055 35.1463C40.1812 34.443 40.9019 33.1743 40.904 31.8042ZM23.9989 8.39717L35.1043 15.0617L23.9989 21.7262L12.8936 15.0617L23.9989 8.39717ZM10.995 31.8042V18.4752L22.0483 25.1072V38.4363L10.995 31.8042ZM25.9495 38.4363V25.1072L37.0028 18.4752V31.8042L25.9495 38.4363Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemFile);
export default __webpack_public_path__ + "static/media/systemFile.e56a116e0b59736a436aadfc1988c65d.svg";
export { ForwardRef as ReactComponent };